import {combineReducers} from 'redux'
import cardItems from './reducer';
import adminPackageCart from './adminPackageReducer';

export default combineReducers(
  {
    cardItems,
    adminPackageCart
  })